import React, { useCallback } from 'react';
import { Button, Col, Form, Spinner } from 'react-bootstrap';
import { useFormik } from 'formik';
import { FormField } from './FormField';
import { getValidationSchemaForFields } from '../../../util';
import { useEscCallback } from './utils';

import './form-field.css';

const passFields = [
    {
        id: 'oldPass',
        name: 'Текущий пароль',
        inputType: 'password',
        required: true,
    },
    {
        id: 'pass',
        name: 'Новый пароль',
        inputType: 'password',
        required: true,
    },
    {
        id: 'confirmPass',
        name: 'Повторить пароль',
        inputType: 'password',
        required: true,
    },
];

const schema = getValidationSchemaForFields(passFields);

const initialFormData = {};

export function FormPassEditField(props) {
    const { submitting, onSubmit, onCancel, errors, clearErrors, ...otherProps } = props;

    const handleCancelClick = useCallback(
        (e) => {
            if (onCancel) onCancel(e, passFields[1]);
        },
        [onCancel]
    );
    const handleFieldChange = useCallback(
        (val, name) => {
            if (errors && errors[name]) clearErrors();
        },
        [errors, clearErrors]
    );
    const handleSubmit = useCallback(
        (values) => {
            if (onSubmit) onSubmit(values);
        },
        [onSubmit]
    );

    useEscCallback(handleCancelClick);

    const formik = useFormik({
        initialValues: initialFormData,
        validate: schema.validate,
        onSubmit: handleSubmit,
    });
    const saveBtnDisabled = formik.isValidating || submitting || !formik.dirty || errors || !formik.isValid;

    return (
        <Form onSubmit={formik.handleSubmit} noValidate>
            {passFields.map((field, i) => (
                <Form.Group key={field.id}>
                    <FormField
                        {...otherProps}
                        field={field}
                        formik={formik}
                        onChange={handleFieldChange}
                        errors={errors}
                        autoFocus={i === 0}
                    />
                </Form.Group>
            ))}
            <Form.Row className="mt-3">
                <Col>
                    <Button variant="outline-primary" type="submit" className="px-5 w-100" disabled={saveBtnDisabled}>
                        {submitting && (
                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                        )}
                        <span>Сохранить</span>
                    </Button>
                </Col>
                <Col>
                    <Button
                        variant="outline-secondary"
                        type="reset"
                        className="px-5 w-100"
                        onClick={handleCancelClick}
                        disabled={submitting}
                    >
                        Отмена
                    </Button>
                </Col>
            </Form.Row>
        </Form>
    );
}
